export const CLOSE_NAV = 'CLOSE_NAV';
export const OPEN_NAV = 'OPEN_NAV';

export const openNav = () => ({ type: 'OPEN_NAV' });

export const closeNav = () => ({ type: 'CLOSE_NAV' });



// WEBPACK FOOTER //
// ./src/actions/navActions.js